import styles from './index.module.scss';
import { DelayRedeemInfo } from '@/types/unstake';
import { formatUTC, getTime } from '@/utils/day';
import { useState, useEffect, useRef } from 'react';
import { useFm } from '@web3/base-hooks';

interface Props {
  show: boolean;
  delayRedeemInfo: DelayRedeemInfo;
  showUpdateTime?: boolean;
}
export const DelayPeriod = (props: Props) => {
  const { show = false, showUpdateTime = false, delayRedeemInfo } = props;
  const fm = useFm();
  const [endTime, setEndTime] = useState(0);
  const [updateTime, setUpdateTime] = useState(0);

  const countdownTimer = useRef<ReturnType<typeof setInterval>>();

  useEffect(() => {
    if (!delayRedeemInfo?.currentEpochRemain) return;

    setEndTime(delayRedeemInfo?.finalTime);

    // 不需要倒计时时，不设置定时器
    if (!showUpdateTime) {
      clearInterval(countdownTimer.current);
      return;
    }

    if (countdownTimer.current) {
      clearInterval(countdownTimer.current);
    }

    countdownTimer.current = setInterval(() => {
      if (delayRedeemInfo?.currentEpochRemain) {
        setUpdateTime((time) => {
          if (time >= 1000) {
            return time - 1000;
          }
          clearInterval(countdownTimer.current);
          return 0;
        });
      }
    }, 1000);

    setUpdateTime((delayRedeemInfo?.currentEpochRemain ?? 0) * 1000);

    return () => {
      clearInterval(countdownTimer.current);
    };
  }, [delayRedeemInfo?.currentEpochRemain, showUpdateTime]);

  if (!show) return null;

  return (
    <div className={styles.container}>
      <div className={styles.update}>
        <div className={styles.text}>{fm('cycleUpdateTime')}</div>
        <div className={styles.time}>
          Epoch
          {showUpdateTime
            ? ` ${delayRedeemInfo?.currentEpoch ?? ''} （${getTime(updateTime)}）`
            : ` ${delayRedeemInfo?.currentEpoch ?? ''}`}
        </div>
      </div>
      <div className={styles.end}>
        <div className={styles.text}>{fm('maturityDate')}</div>
        <div className={styles.time}>{`${formatUTC(endTime)} UTC+0`}</div>
      </div>
    </div>
  );
};
